<template>
  <div class="container">
    <div class="row font-size-lg">
      <span class="col">
        <button
          class="btn btn-link underline-link-from-center m-0 text-left wc-coupon__name font-size-base font-weight-bold"
          @click="showDetails()"
          v-if="coupon.details"
          ref="couponBtnRef"
        >
          {{ coupon.name }}
        </button>
        <span class="wc-coupon__name text-left text-primary" ref="couponBtnRef" v-else>{{
          coupon.name
        }}</span>
      </span>
      <span class="wc-coupon__expiration col text-right pt-2 font-size-sm" v-if="coupon.expiration">
        {{ $t('goodThrough') }}{{ coupon.expiration | formatDate }}
      </span>
    </div>
  </div>
</template>

<script>
import ModalService from '@/modules/modals/services/modal.service';
import WCCouponDetailsModal from '../WCCouponDetailsModal/WCCouponDetailsModal.vue';

export default {
  name: 'WCCoupons',
  props: {
    coupon: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async showDetails() {
      try {
        await ModalService.open(WCCouponDetailsModal, { coupon: this.coupon });
      } catch (error) {
        console.error(error);
      } finally {
        if (this.$refs.couponBtnRef) this.$refs.couponBtnRef.focus();
      }
    },
  },
};
</script>
